import React from 'react';
import PropTypes from 'prop-types';

import { Flex, SvgIcon, Text } from 'Components/Base';
import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';

const AttachmentHeader = ({ title, description, icon }) => {
  const { isMobile } = useCompatibleDisplay();
  return (
    <>
      <Flex alignItems={'center'}>
        <SvgIcon color={'clear.clearDark'} icon={icon} size={24} mr={2} />
        <Text textStyle={isMobile ? 'subtitle1' : 'heading5'} color={'clear.clearDark'}>
          {title}
        </Text>
      </Flex>
      <Text textStyle={'body1'} color={'textColor.secondary'} mt={4}>
        {description}
      </Text>
    </>
  );
};

AttachmentHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.func,
};

export default AttachmentHeader;
